"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MultipleEdition = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/asyncToGenerator"));

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectSpread2"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _Modal = require("../../organisms/Modal");

var _EditionTabs = require("../../molecules/EditionTabs");

var _Table = require("../../organisms/Table");

var _beenhere = _interopRequireDefault(require("../../../assets/images/Icons/beenhere.svg"));

var _closeMagenta = _interopRequireDefault(require("../../../assets/images/Icons/close-magenta.svg"));

var _styles = require("./styles");

var _rejectIcon = _interopRequireDefault(require("../../../assets/images/generalButton/rejectIcon.svg"));

var _genericModalCheck = _interopRequireDefault(require("../../../assets/images/genericModal/genericModalCheck.svg"));

var _utils = require("./utils");

var _ButtonV = require("../../atoms/ButtonV2");

var _TagAndInput = require("../../molecules/TagAndInput");

var _GenericModal = require("../../atoms/GenericModal");

var _ScreenHeader = require("../../atoms/ScreenHeader");

var _jsxRuntime = require("react/jsx-runtime");

var MultipleEdition = function MultipleEdition(_ref) {
  var articles = _ref.articles,
      versions = _ref.versions,
      onClose = _ref.onClose,
      token = _ref.token;

  var _useState = (0, _react.useState)("description"),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      section = _useState2[0],
      setSection = _useState2[1];

  var _useState3 = (0, _react.useState)({
    articleId: "",
    attributeId: "",
    versionId: ""
  }),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      attributeSelected = _useState4[0],
      setAttributeSelected = _useState4[1];

  var _useState5 = (0, _react.useState)([]),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      attributesReviewed = _useState6[0],
      setAttributesReviewed = _useState6[1];

  var _useState7 = (0, _react.useState)([]),
      _useState8 = (0, _slicedToArray2.default)(_useState7, 2),
      descriptionsReviewed = _useState8[0],
      setDescriptionsReviewed = _useState8[1];

  var _useState9 = (0, _react.useState)([]),
      _useState10 = (0, _slicedToArray2.default)(_useState9, 2),
      imagesReviewed = _useState10[0],
      setImagesReviewed = _useState10[1];

  var _useState11 = (0, _react.useState)(false),
      _useState12 = (0, _slicedToArray2.default)(_useState11, 2),
      showRejectModal = _useState12[0],
      setShowRejectModal = _useState12[1];

  var _useState13 = (0, _react.useState)(false),
      _useState14 = (0, _slicedToArray2.default)(_useState13, 2),
      showValidationPanel = _useState14[0],
      setShowValidationPanel = _useState14[1];

  var _useState15 = (0, _react.useState)(""),
      _useState16 = (0, _slicedToArray2.default)(_useState15, 2),
      message = _useState16[0],
      setMessage = _useState16[1];

  var closeValidationPanel = function closeValidationPanel(e) {
    if (!e.target.closest("#validation-panel") || e.target.closest(".validation-option") && showValidationPanel) {
      document.removeEventListener("click", closeValidationPanel, false);
      setShowValidationPanel(false);
    }
  };

  var _useState17 = (0, _react.useState)({
    columns: [],
    data: []
  }),
      _useState18 = (0, _slicedToArray2.default)(_useState17, 2),
      currentData = _useState18[0],
      setCurrentData = _useState18[1];

  var _useReducer = (0, _react.useReducer)(_utils.dataReducer, {
    description: {
      data: []
    },
    datasheet: {
      data: []
    },
    images: {
      data: []
    }
  }),
      _useReducer2 = (0, _slicedToArray2.default)(_useReducer, 2),
      dataServices = _useReducer2[0],
      setDataServices = _useReducer2[1];

  var _useState19 = (0, _react.useState)(),
      _useState20 = (0, _slicedToArray2.default)(_useState19, 2),
      modalFromTable = _useState20[0],
      setModalFromTable = _useState20[1];

  var _useReducer3 = (0, _react.useReducer)(_utils.modalReducer, {
    showModal: false
  }),
      _useReducer4 = (0, _slicedToArray2.default)(_useReducer3, 2),
      modal = _useReducer4[0],
      setModal = _useReducer4[1];

  function callbackToInitData() {
    (0, _utils.initData)(setDataServices, articles, versions, token);
  }

  (0, _react.useEffect)(function () {
    callbackToInitData();
  }, []);
  (0, _react.useEffect)(function () {
    var _setDataColumns = (0, _utils.setDataColumns)(section, dataServices[section], token, setModalFromTable, setDataServices, setModal, setShowValidationPanel, setAttributeSelected, setShowRejectModal, setAttributesReviewed, setMessage, showValidationPanel, attributeSelected, attributesReviewed, descriptionsReviewed, imagesReviewed),
        _setDataColumns2 = (0, _slicedToArray2.default)(_setDataColumns, 2),
        columns = _setDataColumns2[0],
        data = _setDataColumns2[1];

    setCurrentData({
      columns: columns,
      data: data
    });
  }, [section, dataServices, attributeSelected, showValidationPanel, attributesReviewed, descriptionsReviewed, imagesReviewed]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Container, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "tabs",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_EditionTabs.EditionTabs, {
          getSection: setSection
        }), " "]
      }), " ", /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
        src: _beenhere.default,
        alt: "beenhere"
      })]
    }), " ", /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "action_buttons",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
        src: _closeMagenta.default,
        alt: "Cerrar",
        onClick: function onClick() {
          window.location.href = "/products";
        } //onClick={() => onClose && onClose()}

      }), " "]
    }), " ", /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "table",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Table.Table, {
        withCheckbox: true,
        columns: currentData.columns,
        data: currentData.data,
        withTooltip: true
      }), " "]
    }), " ", modalFromTable, " ", /*#__PURE__*/(0, _jsxRuntime.jsx)(_Modal.Modal, (0, _objectSpread2.default)({}, modal)), " ", showRejectModal && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Modal.Modal, {
      title: "Agregar mensaje de rechazo",
      show: showRejectModal,
      customComponent: /*#__PURE__*/(0, _jsxRuntime.jsx)(_TagAndInput.TagAndInput, {
        inputType: "textarea",
        inputId: "modal-message-box",
        index: 0,
        color: "white"
      }),
      buttons: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_ButtonV.ButtonV2, {
        type: "white",
        label: "Cancelar",
        size: 12,
        onClick: function onClick() {
          setShowRejectModal(false);
        }
      }, "btn-Cancelar"), /*#__PURE__*/(0, _jsxRuntime.jsx)(_ButtonV.ButtonV2, {
        type: "pink",
        label: "Aceptar",
        size: 12,
        onClick: /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
          var body, comment, index;
          return _regenerator.default.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  body = document.querySelector("#modal-message-box .ql-container .ql-editor > p").innerHTML;
                  comment = [{
                    type: "comment",
                    value: body === null || body === void 0 ? void 0 : body.replace(/<.*?\/?>/gm, "")
                  }];

                  if (section == "description" || section == "datasheet") {
                    if (section == "datasheet") {
                      index = attributesReviewed.findIndex(function (e) {
                        return e.articleId === attributeSelected.articleId && e.attributeId === attributeSelected.attributeId && e.versionId === attributeSelected.versionId;
                      });
                      attributesReviewed[index].isApproved = false;
                      attributesReviewed[index].isReviewed = true;
                      attributesReviewed[index].comment = comment[0].value;
                    }

                    if (section == "description") {
                      index = descriptionsReviewed.findIndex(function (e) {
                        return e.articleId === attributeSelected.articleId && e.attributeId === attributeSelected.attributeId && e.versionId === attributeSelected.versionId;
                      });
                      descriptionsReviewed[index].isApproved = false;
                      descriptionsReviewed[index].isReviewed = true;
                      descriptionsReviewed[index].comment = comment[0].value;
                      console.log(descriptionsReviewed[index]);
                    }

                    document.getElementById("button_" + attributeSelected.articleId + "_" + attributeSelected.attributeId + "_" + attributeSelected.versionId).src = _rejectIcon.default;
                  }

                  if (section == "images") {
                    index = imagesReviewed.findIndex(function (e) {
                      return e.articleId === attributeSelected.articleId && e.imageId === attributeSelected.attributeId && e.versionId === attributeSelected.versionId;
                    });
                    imagesReviewed[index].isApproved = false;
                    imagesReviewed[index].isReviewed = true;
                    imagesReviewed[index].comment = comment[0].value;
                    console.log(imagesReviewed[index]);
                  }

                  document.getElementById("button_" + attributeSelected.articleId + "_" + attributeSelected.attributeId + "_" + attributeSelected.versionId).src = _rejectIcon.default;
                  setShowRejectModal(false);

                case 6:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }))
      }, "btn-Aceptar")]
    }), " ", message.length > 0 && /*#__PURE__*/(0, _jsxRuntime.jsx)(_GenericModal.GenericModal, {
      componentsArray: [/*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
        src: _genericModalCheck.default,
        alt: "success icon"
      }, "1"), /*#__PURE__*/(0, _jsxRuntime.jsx)(_ScreenHeader.ScreenHeader, {
        headerType: "retailer-name-header",
        text: message,
        color: "white"
      }, "2")],
      onClick: function onClick() {
        setMessage("");
        callbackToInitData();
      }
    }), " "]
  });
};

exports.MultipleEdition = MultipleEdition;